import { Column, Entity, Index, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { Utils } from '../service/utils.service';
import { INote } from './interface/INote';
import { IInstallation } from './interface/IInstallation';
import { IBuilding } from './interface/IBuilding';
import { IVerification } from './interface/IVerification';

@Entity('note')
export class Note extends BaseEntity implements INote{
  apiMapping = {
    id: 'extId',
    title: 'title',
    description: 'description',
    createdDate: {
      type: 'Date',
      fieldName: 'createdDate',
    },
    updatedDate: {
      type: 'Date',
      fieldName: 'updatedDate',
    },
    isNew: 'isNew',
    isDeleted: 'isDeleted'
  };

  @PrimaryGeneratedColumn()
  id: number;

  @Column({ nullable: true })
  @Index()
  extId: number;

  @Column({ nullable: true })
  title: string;

  @Column({ nullable: true })
  titleSearch: string;

  @Column({ nullable: true })
  description: string;

  @Column({ nullable: true })
  createdDate: number;

  @Column({ nullable: true })
  updatedDate: number;

  @Column({ nullable: true })
  isNew: boolean;

  @Column({ nullable: true })
  isDeleted: boolean;

  @ManyToOne('Installation')
  installation: IInstallation;

  @ManyToOne('Building')
  building: IBuilding;

  @ManyToOne('Verification', 'notes')
  @JoinColumn()
  verification: IVerification;

  async fromApi(data: any, update = false) {
    await super.fromApi(data, update);
    this.titleSearch = Utils.removeAccents(this.title);
    return this;
  }
}
